// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ia-0";
export var fileCarousel = "_ia-2";
export var removeFileButton = "_ia-1";